import { TabLink } from '#components/patterns/tab-links/TabLink.tsx';
import { TabLinks } from '#components/patterns/tab-links/TabLinks.tsx';
import type { EndpointOIDC } from '#dn-types/endpoint-oidc.ts';
import type { OIDCProvider } from '#dn-types/oidc-provider.ts';
import { AdminOIDCList } from '../list/AdminOIDCList.tsx';
import { EndpointOIDCList } from '../list/EndpointOIDCList.tsx';
import { EmptyAdminIdentityProvider } from '../sso-page/empty/EmptyAdminIdentityProvider.tsx';
import { useSSOTabs } from './useSSOTabs.ts';

type Props = {
  adminIDPs: OIDCProvider[];
  endpointIDPs: EndpointOIDC[];
};

export function SSOTabs({ adminIDPs, endpointIDPs }: Props) {
  const { tabLinkProps } = useSSOTabs();
  return (
    <TabLinks
      tabs={
        <>
          <TabLink {...tabLinkProps.admin}>Admin</TabLink>
          <TabLink {...tabLinkProps.endpoint}>Endpoints</TabLink>
        </>
      }
    >
      <div>
        {adminIDPs[0] === undefined ?
          <EmptyAdminIdentityProvider />
        : <AdminOIDCList idps={adminIDPs} />}
      </div>
      <div>
        <EndpointOIDCList idps={endpointIDPs} />
      </div>
    </TabLinks>
  );
}
